(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('stocksOnLocation', {
        templateUrl: 'views/components/views/stocksOnLocation/stocksOnLocation.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stocksOnLocationService', function ($stateParams, stocksOnLocationService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let stockLocationKeyno = $stateParams.stocklocation_keyno;
            
            vm.model = {
                info: {},
                itemsListStocksOnLocation: []
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadInfo() {
                vm.model.info = (await stocksOnLocationService.getInfo({ stocklocation_keyno: stockLocationKeyno }))[0];
            }

            async function loadStocksOnLocation() {
                vm.model.itemsListStocksOnLocation = await stocksOnLocationService.listStocksOnLocation({ stocklocation_keyno: stockLocationKeyno });
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadInfo();
                loadStocksOnLocation();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
